import {remCalc} from '../../_utils'

export default {
    sizes: {
        small: {
            input: {
                paddingX: 'var(--chakra-sizes-input-small-paddingX)',
                paddingY: 'var(--chakra-sizes-input-small-paddingY)',
                height: 'var(--chakra-sizes-input-small-height)',
                borderRadius: 'medium-1',
            },
            container: {
                '.PhoneInput input': {
                    paddingY: 'var(--chakra-sizes-input-small-paddingY)',
                    height: 'var(--chakra-sizes-input-small-height)',
                    borderRadius: 'medium-1',
                },
                '.PhoneInput ~ .chakra-input__right-element': {
                    height: 'var(--chakra-sizes-input-small-height)',
                },
            },
        },
        base: {
            input: {
                paddingX: 'var(--chakra-sizes-input-base-paddingX)',
                paddingY: 'var(--chakra-sizes-input-base-paddingY)',
                height: 'var(--chakra-sizes-input-base-height)',
                borderRadius: 'large',
            },
            container: {
                '.PhoneInput input': {
                    paddingY: 'var(--chakra-sizes-input-base-paddingY)',
                    height: 'var(--chakra-sizes-input-base-height)',
                    borderRadius: 'large',
                },
                '.PhoneInput ~ .chakra-input__right-element': {
                    height: 'var(--chakra-sizes-input-base-height)',
                },
            },
        },
        large: {
            input: {
                paddingX: 'var(--chakra-sizes-input-large-paddingX)',
                paddingY: 'var(--chakra-sizes-input-large-paddingY)',
                height: 'var(--chakra-sizes-input-large-height)',
                borderRadius: 'large',
            },
            container: {
                '.PhoneInput input': {
                    paddingY: 'var(--chakra-sizes-input-large-paddingY)',
                    height: 'var(--chakra-sizes-input-large-height)',
                    borderRadius: 'large',
                },
                '.PhoneInput ~ .chakra-input__right-element': {
                    height: 'var(--chakra-sizes-input-large-height)',
                },
            },
        },
        xl: {
            input: {
                paddingX: 'var(--chakra-sizes-input-xl-paddingX)',
                paddingY: 'var(--chakra-sizes-input-xl-paddingY)',
                height: 'var(--chakra-sizes-input-xl-height)',
                borderRadius: 'large-1',
            },
            container: {
                '.PhoneInput input': {
                    paddingY: 'var(--chakra-sizes-input-xl-paddingY)',
                    height: 'var(--chakra-sizes-input-xl-height)',
                    borderRadius: 'large-1',
                },
                '.PhoneInput ~ .chakra-input__right-element': {
                    height: 'var(--chakra-sizes-input-xl-height)',
                },
            },
        },
    },

    baseStyle: () => ({
        container: {
            width: '100%',
            position: 'relative',
            marginLeft: remCalc(3),
            marginRight: remCalc(3),
            '.PhoneInput': {
                width: '100%',
            },
            '.PhoneInput input': {
                textStyle: 'body-small',
                color: 'foreground.neutral.default',
                paddingLeft: remCalc(52),
                paddingRight: remCalc(16),
                width: '100%',
                border: '1px solid var(--chakra-colors-border-neutral-highlight)',
                bg: 'background.neutral.default',
                borderRadius: 'large',
                outline: 'none',
                transition: 'padding .15s ease',
                boxShadow:
                    '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',
            },
            '&[data-initial=true] .PhoneInput input': {
                paddingTop: 'calc(var(--chakra-sizes-input-xl-paddingY) + 4px)',
                paddingBottom: 'calc(var(--chakra-sizes-input-xl-paddingY) - 6px)',
            },
            '.PhoneInput input:hover': {
                bg: 'background.base.elevated',
            },
            '.PhoneInput input:focus-visible': {
                border: 'none !important',
                outline: 'none !important',
            },
            '.PhoneInput:focus-within input': {
                bg: 'background.base.elevated !important',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs) !important',
            },
            '.PhoneInput input:invalid': {
                color: 'foreground.negative.default',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',
            },
            '.PhoneInput input:disabled': {
                bg: 'background.base.under !important',
                color: 'foreground.neutral.dim !important',
                border: '1px solid var(--chakra-colors-border-neutral-highlight) !important',
                cursor: 'not-allowed',
            },
            '.PhoneInput input::placeholder': {
                color: 'foreground.neutral.subtle !important',
            },
            '.PhoneInput .PhoneInputCountry': {
                border: 0,
                background: 'none',
                position: 'relative',
                left: remCalc(12),
                mr: remCalc(-36),
                transition: 'top .15s ease',
            },
            '&[data-initial=true] .PhoneInput .PhoneInputCountry': {
                top: remCalc(6),
            },
        },
        popover: {},
        input: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',
            bg: 'background.neutral.default',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',

            _hover: {
                bg: 'background.base.elevated',
            },

            _focus: {
                bg: 'background.base.elevated',
            },

            _focusVisible: {
                bg: 'background.base.elevated',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
            },

            _focusWithin: {
                bg: 'background.base.elevated',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
            },

            _invalid: {
                color: 'foreground.negative.default',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',
            },

            _disabled: {
                bg: 'background.base.under !important',
                color: 'foreground.neutral.dim !important',
                border: '1px solid var(--chakra-colors-border-neutral-highlight) !important',
                cursor: 'not-allowed',
            },

            _placeholder: {
                color: 'foreground.neutral.subtle !important',
            },
        },
        placeholderLabel: {
            textStyle: 'body-xxsmall',
            color: 'foreground.neutral.subtle',
            fontWeight: 'regular',
            lineHeight: remCalc(12),
        },
        lookupContainerAbs: {
            position: 'absolute',
            width: '100%',
            zIndex: 100,
        },
        lookupContainer: {
            width: '100%',
            position: 'relative',
        },
        lookupInput: {
            height: remCalc(40),
            textStyle: 'body-small',
            lineHeight: remCalc(18),
            fontWeight: 'regular',
            color: 'foreground.neutral.default',
            border: 'none',
        },
        lookupInnerContainer: {
            maxHeight: remCalc(208),
            overflowY: 'auto',
            marginTop: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',
            bg: 'background.base.elevated',
            color: 'foreground.neutral.default',
            borderRadius: 'large-1',
        },
        lookupScrollbar: {
            '::-webkit-scrollbar': {
                width: remCalc(7),
                borderRadius: remCalc(13),
                backgroundClip: 'padding-box',
                border: '0.625rem solid transparent',
            },
            '::-webkit-scrollbar-thumb': {
                width: remCalc(16),
                borderRadius: remCalc(13),
                backgroundClip: 'padding-box',
                border: '0.625rem solid transparent',
                boxShadow: 'inset 0 0 0 0.625rem',
                background: 'button.border.inverse-primary-focused',
            },
        },
        lookupHighlight: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            lineHeight: remCalc(18),
            color: 'foreground.neutral.default',
            padding: {
                base: 'xxxsmall.base',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
                xl: 'xxxsmall.xl',
            },
            display: 'flex',
            flexDirection: 'column',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
        },
        lookupItem: {
            padding: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
            borderRadius: 'large',
            cursor: 'pointer',
            _hover: {
                bg: 'background.neutral.hover',
            },
        },
        manualAddressBtnContainer: {
            marginTop: {
                base: 'xxxsmall.base',
                sm: 'xxxsmall.sm',
                md: 'xxxsmall.md',
                lg: 'xxxsmall.lg',
            },
        },
        manualAddressBtn: {
            variant: 'text-button',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        textArea: {
            height: remCalc(130),
            padding: {
                base: 'xxsmall.base',
                sm: 'xxsmall.sm',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
            },
            textStyle: 'body-small',
            bg: 'background.neutral.default',
            color: 'foreground.neutral.default',
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',
            boxShadow:
                '0 0 0 1px var(--chakra-colors-border-neutral-highlight) inset, 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 1px var(--chakra-shadows-neutral-xs)',

            _placeholder: {
                color: 'foreground.neutral.subtle',
            },

            _hover: {
                bg: 'background.base.elevated',
            },

            _focus: {
                bg: 'background.base.elevated',
            },

            _focusVisible: {
                bg: 'background.base.elevated',
                outline: 'none',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-accent-md), 0 0 0 1px var(--chakra-shadows-accent-xl), 0 0 0 4px var(--chakra-shadows-accent-xs)',
            },

            _invalid: {
                color: 'foreground.negative.default',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',

                _focusVisible: {
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs) !important',
                },
            },

            _disabled: {
                bg: 'background.base.under !important',
                color: 'foreground.neutral.dim !important',
                border: '1px solid var(--chakra-colors-border-neutral-highlight) !important',
                cursor: 'not-allowed',
            },

            '&:not(:placeholder-shown)': {
                bg: 'background.base.elevated !important',
            },
        },
        helperText: {
            marginTop: remCalc(8),
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
        },
        errorText: {
            marginTop: remCalc(8),
            textStyle: 'body-xxsmall',
            color: 'foreground.negative.default',
        },
        successIcon: {
            color: 'foreground.positive.default',
            position: 'absolute',
            right: remCalc(12),
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            width: remCalc(16),
            height: remCalc(16),
        },
        infoIcon: {
            color: 'foreground.neutral.default',
            cursor: 'pointer',
            position: 'absolute',
            right: remCalc(12),
            top: '50%',
            transform: 'translateY(-50%)',
            width: remCalc(16),
            height: remCalc(16),
        },
        counter: {
            position: 'absolute',
            bottom: remCalc(8),
            right: remCalc(16),
            textStyle: 'body-xxsmall',
            color: 'foreground.neutral.dim',
        },
    }),
    variants: {
        success: {
            input: {
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-positive-md), 0 0 0 1px var(--chakra-shadows-positive-xl), 0 0 0 4px var(--chakra-shadows-positive-xs)',
            },
            container: {
                '.PhoneInput input': {
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-positive-md), 0 0 0 1px var(--chakra-shadows-positive-xl), 0 0 0 4px var(--chakra-shadows-positive-xs)',
                },
            },
        },
        invalid: {
            input: {
                color: 'foreground.negative.default',
                boxShadow:
                    '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',
            },
            container: {
                '.PhoneInput input': {
                    color: 'foreground.negative.default',
                    boxShadow:
                        '0 3px 6px 0 var(--chakra-shadows-negative-md), 0 0 0 1px var(--chakra-shadows-negative-xl), 0 0 0 4px var(--chakra-shadows-negative-xs)',
                },
            },
        },
    },
    parts: [
        'container',
        'label',
        'input',
        'helperText',
        'errorText',
        'counter',
        'inputRightElement',
        'successIcon',
        'infoIcon',
        'textArea',
        'lookupContainer',
        'lookupInput',
        'lookupInnerContainer',
        'lookupItem',
        'lookupHighlight',
        'lookupScrollbar',
        'manualAddressBtnContainer',
        'manualAddressBtn',
    ],
    defaultProps: {size: 'xl'},
}
